import { render, staticRenderFns } from "./invitationCode.vue?vue&type=template&id=237220b4&scoped=true"
import script from "./invitationCode.vue?vue&type=script&lang=js"
export * from "./invitationCode.vue?vue&type=script&lang=js"
import style0 from "./invitationCode.vue?vue&type=style&index=0&id=237220b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237220b4",
  null
  
)

export default component.exports